import DealTable from "./DealTable";

export default DealTable;



// WEBPACK FOOTER //
// ./src/components/DealTable/index.js